import type { Activity, Profile, Submission } from '../types'

export const demoTeacher: Profile = { id: 'teacher-1', displayName: '김선생님', role: 'teacher', avatarColor: '#6657d9' }
export const demoStudents: Profile[] = [
  { id: 'student-1', displayName: '김하늘', role: 'student', avatarColor: '#3b82f6' },
  { id: 'student-2', displayName: '박지우', role: 'student', avatarColor: '#f97316' },
  { id: 'student-3', displayName: '이서준', role: 'student', avatarColor: '#14b8a6' },
  { id: 'student-4', displayName: '최유진', role: 'student', avatarColor: '#ec4899' },
]

export const demoActivities: Activity[] = [
  { id: 'a1', title: '우리 고장 소개하기', description: '우리 고장의 자랑거리를 조사하고 소개 자료를 만들어요.', emoji: '🏘️', subject: '사회', visibility: 'class', dueDate: '10월 4일', createdAt: '2026-09-23' },
  { id: 'a2', title: '생태계 탐구 보고서', description: '생태계를 이루는 생물의 관계를 관찰하고 정리해요.', emoji: '🌱', subject: '과학', visibility: 'class', dueDate: '10월 11일', createdAt: '2026-09-25' },
  { id: 'a3', title: '내가 만든 짧은 이야기', description: '상상력을 발휘해 나만의 이야기를 써 봐요.', emoji: '✍️', subject: '국어', visibility: 'private', createdAt: '2026-09-28' },
]

export const demoSubmissions: Submission[] = [
  {
    id: 's1', owner: demoStudents[1], activityId: 'a1', title: '한강 공원 사용 설명서',
    reflection: '직접 찍은 사진으로 우리 고장의 좋은 점을 소개했습니다. 사람들이 한강 공원을 더 아껴 주면 좋겠습니다.',
    cover: 'linear-gradient(135deg, #a7d8ff 0%, #e8f4ff 52%, #7ec8a5 52%, #54a77c 100%)',
    files: [{ id: 'f1', name: '한강공원_소개.pdf', type: 'application/pdf', size: 2480000 }],
    createdAt: '2026-09-28', visibility: 'class', praises: { '멋져요': 5, '창의적이에요': 3, '노력했어요': 4 }, myPraises: ['멋져요'],
    comments: [{ id: 'c1', author: demoTeacher, body: '사진과 설명이 잘 어울려서 이해하기 쉬웠어요!', createdAt: '어제', isTeacher: true }],
  },
  {
    id: 's2', owner: demoStudents[2], activityId: 'a2', title: '연못 속 작은 생태계',
    reflection: '학교 연못을 관찰하고 생산자, 소비자, 분해자를 찾아 관계를 그림으로 나타냈습니다.',
    cover: 'linear-gradient(145deg, #d8f3dc 0%, #95d5b2 55%, #52b788 55%, #2d6a4f 100%)',
    files: [{ id: 'f2', name: '연못생태계.pptx', type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation', size: 5100000 }],
    createdAt: '2026-09-27', visibility: 'class', praises: { '멋져요': 2, '창의적이에요': 6, '최고예요': 2 },
    comments: [],
  },
  {
    id: 's3', owner: demoStudents[0], activityId: 'a1', title: '우리 동네 숨은 도서관',
    reflection: '친구들이 잘 모르는 작은 도서관을 찾아가 보고, 이용 방법과 좋은 점을 정리했습니다.',
    cover: 'linear-gradient(135deg, #fee2b3 0%, #ffd166 50%, #ef8354 50%, #d95d39 100%)',
    files: [{ id: 'f3', name: '숨은도서관.jpg', type: 'image/jpeg', size: 1800000 }],
    createdAt: '2026-09-26', visibility: 'class', praises: { '도움이 됐어요': 4, '노력했어요': 5 },
    comments: [],
  },
]
